module.exports = __webpack_public_path__ + "static/blackroom-59e189e9a913e6187454db5df6fc72d2.png";